<div class="conversation-icon-container" [matTooltip]="tooltip">
  <i [ngClass]="iconCls"></i>
</div>
